import * as React from 'react';

import { BackHandler, Dimensions, ActivityIndicator } from 'react-native';
import { Item, Input, Icon, Toast, Form, Spinner, H2, Container, Header, Left, Button, Body, Title, Right, Content, Text } from 'native-base';
import { connect } from 'react-redux';
import GLOBALS from '../../components/globals';
import LocalStorage from '../../api/LocalStorage';
import * as WebBrowser from 'expo-web-browser';
import { WebView } from 'react-native-webview';

class ProfileContainer extends React.Component {
	constructor(props) {
		super(props);
		this.initialState = { loading: true };
		this.state = this.initialState;
	}

	/*componentDidMount() {
		console.log('mount');
	}*/

	onNavigationStateChange(navState) {
		// Here I will catch redirect to login screen calcal.uk - navigate to native login screen
		if (__DEV__) console.log('onNavigationStateChange', navState);
		//this.state.loading && !navState.loading && this.setState({ loading: false });
		return;
		this.setState({
			canGoBack: navState.canGoBack
		});
		var hashed = navState.url.split('#');

		if (hashed.length > 1) {
			var hash = hashed[1];
			this.setState({ currHash: hash });
			if (hash != '') this.urlStack.push(hash);
			if (__DEV__) console.log(hash, this.urlStack);
			//var title = pathProperties[hash]?pathProperties[hash].display:hash;
			//this.props.navigator.updateCurrentRouteParams({ hashname: title });
		}
		/*if (navState.url == HOME_URL) {
			  this.setState({
				loggedIn: true,
			  });
			}*/
	}

	async refreshToken() {
		const signedIn = await LocalStorage.getUserAsync();
		//console.log(signedIn);
		signedIn &&
			this.props.dispatch({
				type: 'SET_USER',
				user: signedIn
			});
	}
	ActivityIndicatorLoadingView() {
		//making a view to show to while loading the webpage
		return <ActivityIndicator size="large" style={{ flex: 1, justifyContent: 'center' }} />;
	}
	render() {
		var headers = {
			access_token: this.props.user?.access_token
		};
		var url = 'https://calcal.uk/your-profile/?access_token=' + this.props.user?.access_token;
		//is the access_token still good?

		if (this.props.user.refreshTime < new Date().getTime() / 1000) {
			__DEV__ && console.log('Profile... access token expired.', this.props.user.refreshTime, new Date().getTime());
			this.refreshToken();
			return (
				<Container>
					<Header>
						<Left>
							<Button transparent onPress={() => this.props.navigation.navigate('Main')}>
								<Icon name="ios-arrow-back" />
							</Button>
						</Left>
						<Body>
							<Title>Profile</Title>
						</Body>
						<Right />
					</Header>
					<Content>
						<H2>Refreshing...</H2>
						<Spinner />
					</Content>
				</Container>
			);
		}

		//const deviceWidth = Dimensions.get('window').width;
		//const deviceHeight = Dimensions.get('window').height;

		return (
			<Container>
				<Header>
					<Left>
						<Button transparent onPress={() => this.props.navigation.navigate('Main')}>
							<Icon name="ios-arrow-back" />
						</Button>
					</Left>
					<Body>
						<Title>Profile</Title>
					</Body>
					<Right />
				</Header>
				<Content>
					<WebView
						style={{ flex: 1, width: '100%', height: 2000, backgroundColor: 'transparent' }}
						ref={'webview'}
						scalesPageToFit={true}
						automaticallyAdjustContentInsets={true}
						startInLoadingState={true}
						scrollEnabled={false}
						onNavigationStateChange={n => this.onNavigationStateChange(n)}
						renderLoading={this.ActivityIndicatorLoadingView}
						injectedJavaScript={
							'document.getElementsByTagName("header")[0].style.display="none";     document.getElementsByTagName("footer")[0].style.display="none";  document.getElementsByClassName("site-main")[0].style.padding=0;'
						}
						source={{ uri: url }}
					/>
				</Content>
			</Container>
		);
	}
}
function bindAction(dispatch) {
	return {
		dispatch
	};
}

const mapStateToProps = state => ({
	user: state.loginReducer.user,
	jwt: state.loginReducer.jwt && state.loginReducer.jwt.token
});

export default connect(mapStateToProps, bindAction)(ProfileContainer);
